import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { Tabs as AntdTabs } from 'antd'
import { LegalFormality } from 'types/legalFormality'
import { ContactContext } from 'contexts/contactContext'
import { LegalFormalitiesContext } from 'contexts/legalFormalitiesContext'

const Tabs = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { contact } = useContext(ContactContext)
  const { legalFormalities } = useContext(LegalFormalitiesContext)

  const items = legalFormalities.map((formality: LegalFormality) => {
    const token = formality.purchase.identificationToken
    return {
      key: formality.id,
      label: t(`products:identificationToken.${token}`, 'unknown formality'),
    }
  })

  const navToFormality = (id: string) => {
    navigate(`/contacts/${contact.id}/legal_formalities/${id}`)
  }

  return (
    <TabsContainer>
      <AntdTabs defaultActiveKey="1" items={items} onChange={navToFormality} />
    </TabsContainer>
  )
}

const TabsContainer = styled.div`
  .ant-tabs-nav {
    margin-bottom: 0px;
  }
`

export default Tabs
